module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "title",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_vm._v("Das weiße Haus")]), _vm._v(" "), _c('h4', {
    staticClass: "calibre1"
  }, [_vm._v("Roman")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('div', {
    staticClass: "motto"
  }, [_c('p', {
    staticClass: "calibre2"
  }, [_c('a', {
    attrs: {
      "id": "page6",
      "title": "wolfeh/wedi"
    }
  }), _vm._v(" Tell me the\ntales,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\nthat to me were so dear,"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\nlong, long ago –"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("\nlong, long ago. "), _c('a', {
    attrs: {
      "id": "page7",
      "title": "wolfeh/wedi"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc4c520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/chapter0_split_001.vue
// module id = 57
// module chunks = 0